import headTeacher from "./head-teacher";
import teacher from "./teacher";
import mediaStaffer from "./media-staffer";
import staffer from "./staffer";
import nurse from "./nurse";
import camp from "./camp";
import contractor from "./contractor";
import director from "./director";
import parentsChatsDev from "./parentsChatsDev";
import duties from "./duties";
import legal from "./legal";

export default {
  namespaced: true,
  modules: {
    "head-teacher": headTeacher,
    teacher,
    "media-staffer": mediaStaffer,
    staffer,
    nurse,
    camp,
    contractor,
    director,
    "parents-chats-dev": parentsChatsDev,
    duties,
    legal,
  },
};
